import React, { useState } from "react";
import Modal from "react-modal";
import Qlinn from "./Qlinn";
import styles from "./Buttons.module.css"

export default function QlinnButton(props) {
    const [showModal, setShowModal] = useState(false);

    const toggleModal = () => {
      setShowModal(!showModal);
    };
    
  return (
    <div
      className={`btn ${styles.qlinn} mr-1`}
      onClick={toggleModal}
      style={{ display: "inline-block" }}>
      {showModal ? (
        <Modal
          isOpen={showModal}
          ariaHideApp={false}
          style={{ content: { padding: "0px" } }}>
          <Qlinn orderId={props.details.orderId} />
        </Modal>
      ) : null}
    </div>
  );
}
